export const GET_SHIFTS_IN_CITY = "GET_SHIFTS_IN_CITY";
export const SET_SHIFTS_IN_CITY = "SET_SHIFTS_IN_CITY";

export const CREATE_SHIFTS_IN_CITY = "CREATE_SHIFTS_IN_CITY";
export const UPDATE_SHIFTS_IN_CITY = "UPDATE_SHIFTS_IN_CITY";
export const UN_REGISTER_SHIFT = "UN_REGISTER_SHIFT";

export const ADD_CITY = "ADD_CITY";
export const GET_CITIES = "GET_CITIES";
export const UPDATE_CITY = "UPDATE_CITY";
export const DELETE_CITY = "DELETE_CITY";
export const ADD_TOWN = "ADD_TOWN";
export const GET_TOWNS = "GET_TOWNS";
export const UPDATE_TOWN = "UPDATE_TOWN";
export const DELETE_TOWN = "DELETE_TOWN";
export const SET_CITIES = "SET_CITIES";
export const SET_TOWNS = "SET_TOWNS";

export const SET_REGION = "SET_REGION";
export const SET_CITY = "SET_CITY";

export const SET_ERROR = "SET_ERROR";
export const SET_SUCCESS = "SET_SUCCESS";

export const set_region = (payload) => ({
  type: SET_REGION,
  payload,
});

export const set_city = (payload) => ({
  type: SET_CITY,
  payload,
});

export const getShiftsInCity = () => ({
  type: GET_SHIFTS_IN_CITY,
});

export const setShiftsInCity = (payload) => ({
  type: SET_SHIFTS_IN_CITY,
  payload,
});

export const createShiftsInCity = (payload) => ({
  type: CREATE_SHIFTS_IN_CITY,
  payload,
});

export const updateShiftsInCity = (payload) => ({
  type: UPDATE_SHIFTS_IN_CITY,
  payload,
});

export const unRegisterCarrierShift = (payload) => ({
  type: UN_REGISTER_SHIFT,
  payload,
});

export const add_city = (payload) => ({
  type: ADD_CITY,
  payload,
});

export const get_cities = (payload) => ({
  type: GET_CITIES,
  payload,
});

export const set_cities = (payload) => ({
  type: SET_CITIES,
  payload,
});

export const update_city = (payload) => ({
  type: UPDATE_CITY,
  payload,
});

export const delete_city = (payload) => ({
  type: DELETE_CITY,
  payload,
});

export const add_town = (payload) => ({
  type: ADD_TOWN,
  payload,
});

export const get_towns = (payload) => ({
  type: GET_TOWNS,
  payload,
});

export const set_towns = (payload) => ({
  type: SET_TOWNS,
  payload,
});

export const update_town = (payload) => ({
  type: UPDATE_TOWN,
  payload,
});

export const delete_town = (payload) => ({
  type: DELETE_TOWN,
  payload,
});

export const setError = (payload) => ({
  type: SET_ERROR,
  payload,
});

export const setSuccess = (payload) => ({
  type: SET_SUCCESS,
  payload,
});
